interface NavItem {
  name: string;
  url: string;
}

export const navItems: NavItem[] = [{ name: "ChatAva", url: "/chatroom" }];
